if (!customElements.get('dsa-track-order')) {
  customElements.define(
    'dsa-track-order',
    class DsaTrackOrder extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.error = this.querySelector('[data-track-error]');
        if (!this.form) return;
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          const order = (this.form.elements.order.value || '').trim().replace(/^#/, '');
          const emailEl = this.form.elements.email;
          const email = emailEl ? (emailEl.value || '').trim() : '';
          if (!order) return this.fail('Vul je ordernummer in.');
          if (emailEl && emailEl.required && !/^\S+@\S+\.\S+$/.test(email)) return this.fail('Vul een geldig e-mailadres in.');
          const template = this.dataset.url || '';
          if (!/^(https?:\/\/|\/)/i.test(template)) return this.fail('De trackinglink is niet ingesteld.');
          const url = template
            .replace(/\{order\}/g, encodeURIComponent(order))
            .replace(/\{email\}/g, encodeURIComponent(email));
          this.fail('');
          if (this.dataset.newTab === 'true') window.open(url, '_blank', 'noopener');
          else window.location.href = url;
        });
      }

      fail(message) {
        if (!this.error) return;
        this.error.textContent = message;
        this.error.hidden = !message;
        if (message) this.form.elements.order.focus();
      }
    }
  );
}
